import { observable, action } from 'mobx';

/**
 * 用户数据
 */
export default class userStore {
  @observable isInvite = true;

  @observable retry = false;

  @observable restTime1 = '10:00';

  @observable restTime2 = 60;

  @observable isInit = true;

  @observable time1 = null;

  @observable time2 = null;

  @observable checkTimer = null;

  // 更改数据
  @action.bound
  setData(data: any) {
    for (const key in data) {
      this[key] = data[key];
    }
  }
}
